import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrunchDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"brunch_dining"}/>
}
